import { connect } from 'react-redux';

import { acceptInvitation, deleteInvitation } from "../actions/invitations";
import { doAcceptUserDomainInvitation } from '../actions/domains';
import { fetchUserProductLicence } from '../actions/licences';

const mapDispatchToProps = (dispatch, {user, invitation, domainInvitation}) => ({
  acceptInvitation: () =>
    dispatch( acceptInvitation(invitation.id, invitation.token, user.id) ),
  denyInvitation: () =>
    dispatch( deleteInvitation(invitation.id, invitation.token) ),
  acceptDomainInvitation: () => 
    dispatch( doAcceptUserDomainInvitation(domainInvitation.id, user.id) )
    .then(_ => dispatch(fetchUserProductLicence(user.id, domainInvitation.licence.plan.product.id))) ,
});

export const withInvitation = connect(undefined, mapDispatchToProps);



// WEBPACK FOOTER //
// ./src/containers/withInvitation.js